export default "__VITE_ASSET__CdisPhua__"